import { DialogContent } from "@material-ui/core";

export default DialogContent;
